import { render, staticRenderFns } from "./OrderNew.vue?vue&type=template&id=12a2c107&scoped=true&"
import script from "./OrderNew.vue?vue&type=script&lang=js&"
export * from "./OrderNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a2c107",
  null
  
)

export default component.exports